module.exports = __webpack_public_path__ + "static/media/bubble-dots4.9824058b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bubble-dots4.svg
// module id = 2465
// module chunks = 7